<template>
  <div>
    <div class="contacts__form-title">{{ $t("Contact Form") }}</div>
    <form @submit.prevent="submit">
      <div class="contacts__form-left">
        <field
          :field="fields.get('name')"
          :model="model"
          :errors="errors"
          layout="nolabel"
        />
        <field
          :field="fields.get('email')"
          :model="model"
          :errors="errors"
          layout="nolabel"
        />
        <field
          :field="fields.get('subject')"
          :model="model"
          :errors="errors"
          layout="nolabel"
        />
      </div>
      <div class="contacts__form-right">
        <field
          :field="fields.get('message')"
          :model="model"
          :errors="errors"
          layout="nolabel"
        />
      </div>
      <fields
        :fields="fields.except('name', 'email', 'subject', 'message')"
        :model="model"
        :errors="errors"
        layout="nolabel"
      />
      <div class="contacts__form-bottom">
        <div class="form-group text-right">
          <button type="submit" class="bordered-btn blue-button">
            {{ $t("Send") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "stylemix-base";

export default {
  name: "Contact",

  mixins: [FormMixin],

  data() {
    return {
      model: window.CONTACT.data,
    };
  },

  created() {
    this.setFields(window.CONTACT.fields);
    let keys = ["name", "email", "subject", "message"];
    keys.forEach((key) => {
      let field = this.fields.get(key);
      field.placeholder = field.label;
    });
  },

  methods: {
    submit() {
      // clear form errors
      this.errors.clear();
      let resolver,
        rejecter,
        promise = new Promise((resolve, reject) => {
          resolver = resolve;
          rejecter = reject;
        });

      grecaptcha.ready(() => {
        // get captcha token
        grecaptcha
          .execute(CAPTCHA_SITE_KEY, { action: "contact" })
          .then((token) => {
            this.$http
              .post(`contact`, { ...this.model, token }, { baseURL: "/" })
              .then((response) => {
                this.$toast.success(
                  this.$t(
                    "Thank you for contacting us. You will be reached out soon."
                  )
                );
                this.resetModel(this.model);
                resolver(response);
              })
              .catch((rejection) => {
                this.$toast.error(rejection.response.data.message);
                if (rejection.response && rejection.response.status === 422) {
                  this.setValidationErrors(rejection.response.data.errors);
                }
                rejecter(rejection);
              });
          });
      });

      this.withUiBlocker(promise, this.$el);
    },
  },
};
</script>
